
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import QrcodeVue from 'qrcode.vue';
import Dialog from '@/components/Dialog.vue';

@Component({
  components: {
    Dialog,
    QrcodeVue,
  },
})
export default class UrlWithQRCode extends Vue {
  @Prop() private hyperlink!: string;

  @Prop() private title!: string;

  @Emit()
  private close() {}
}
